<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- cmd命令行输入命令 $env:NODE_OPTIONS="--openssl-legacy-provider" -->
    <router-view />
  </div>
</template>

<script>
import HelloWorld from './views/index/index.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
</style>
